import leadingZero from './leadingZero'

export function switchDateFormat(date, targetSeparator) {
  if (targetSeparator && date.includes(targetSeparator)) {
    return date;
  }
  const separator = date.includes('.') ? '-' : '.';
  return date.split(/[-.]/).reverse().join(separator);
}

export function formatDate(dateString) {
  const d = new Date(dateString)
  const year = d.getFullYear()
  const month = d.getMonth() + 1
  const day = d.getDate()
  const hours = d.getHours()
  const minutes = d.getMinutes()

  const date = `${leadingZero(day)}.${leadingZero(month)}.${year}`
  const time = `${leadingZero(hours)}:${leadingZero(minutes)}`
  const dateTime = `${date} ${time}`

  return {
    date,
    time,
    dateTime
  }
}
